<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-size-65">
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-primary">
            <div class="card-text">
              <h4 class="title">
                {{ client.name }}&nbsp;
                <Badge v-if="client.stateId === 2" type="warning"
                  >Archived</Badge
                >
              </h4>
            </div>
            <edit-button @edit-click="editClient"></edit-button>
          </md-card-header>
          <md-card-content>
            <div class="md-layout">
              <div class="md-layout-item md-small-size-100 md-size-33">
                <address>
                  {{ client.address1 }}
                  <br />
                  <template v-if="client.address2">
                    {{ client.address2 }}
                    <br />
                  </template>
                  <template v-if="client.address3">
                    {{ client.address3 }}
                    <br />
                  </template>
                  <template v-if="client.city">
                    {{ client.city }}
                    <br />
                  </template>
                  <template v-if="client.county">
                    {{ client.county }}
                    <br />
                  </template>
                  <template v-if="client.country">
                    {{ client.country }}
                    <br />
                  </template>
                  {{ client.postcode }}
                </address>
              </div>
              <div
                v-show="!client.statutoryInspectionsEnabled"
                class="md-layout-item md-small-size-100 md-size-33"
              >
                <p>
                  <strong>QUOTE ONLY</strong>
                </p>
              </div>
              <div
                v-show="client.statutoryInspectionsEnabled"
                class="md-layout-item md-small-size-100 md-size-33"
              >
                <p>
                  <strong>Stat. Insp. reminder email frequency</strong>
                  <br />
                  {{ client.reminderIntervalInWeeks }} week(s) prior to expiry
                </p>
                <p>
                  <strong>Stat. Insp. overdue email frequency</strong>
                  <br />
                  {{ client.overdueIntervalInWeeks }} week(s) after expiry
                </p>
              </div>
            </div>
          </md-card-content>
        </md-card>
        <md-card>
          <md-card-header class="md-card-header-text md-card-header-primary">
            <div class="card-text">
              <h4 class="title">Sites</h4>
            </div>
            <add-button
              :disabled="contacts.length === 0"
              @add-click="addSite"
            ></add-button>
          </md-card-header>
          <md-card-content>
            <siteList v-if="contacts.length !== 0"></siteList>
            <span v-if="contacts.length === 0">
              You cannot create a site until you have added a contact.
            </span>
          </md-card-content>
        </md-card>
      </div>
      <div class="md-layout-item md-medium-size-100 md-size-35">
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-primary">
            <div class="card-text">
              <h4 class="title">Contacts</h4>
            </div>
            <add-button @add-click="addClientContact"></add-button>
          </md-card-header>
          <md-card-content><contactList></contactList></md-card-content>
        </md-card>
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-primary">
            <div class="card-icon">
              <md-icon>library_books</md-icon>
            </div>
            <h4 class="title">Reports</h4>
          </md-card-header>
          <md-card-content>
            <div class="md-layout">
              <div class="md-layout-item md-medium-size-100 md-size-100">
                <md-button
                  class="md-primary"
                  @click="onGenerateActivePlantReport()"
                  >Active Plant</md-button
                ><br />
                <md-button
                  class="md-primary"
                  @click="onGenerateClientPlantSummarytReport()"
                  >Plant Summary</md-button
                >
              </div>
            </div>
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Badge } from "@/components";
import SiteList from "./sites/SiteList";
import ContactList from "./client-contacts/ClientContactListing";

export default {
  name: "ClientView",
  components: {
    SiteList,
    ContactList,
    Badge
  },
  computed: {
    ...mapGetters({
      client: "data-management-client/client",
      contacts: "data-management-client/clientContacts"
    })
  },
  created() {
    this.$store.dispatch(
      "data-management-client/getClient",
      this.$route.params.clientId
    );
  },
  methods: {
    addSite() {
      this.$router.push({ name: "Add Site" });
    },
    editClient() {
      this.$router.push({
        name: "Edit Client",
        params: { clientId: this.client.id }
      });
    },
    addClientContact() {
      this.$router.push({
        name: "Add Client Contact",
        params: { clientId: this.client.id }
      });
    },
    onGenerateActivePlantReport() {
      this.$store.dispatch("report/getActivePlantReport", {
        clientId: this.$route.params.clientId
      });
    },
    onGenerateClientPlantSummarytReport() {
      this.$store.dispatch("report/getClientActivePlantSummaryReport", {
        clientId: this.$route.params.clientId
      });
    }
  }
};
</script>

<style></style>
